import React from 'react';
import { Box, Typography } from '@mui/material';

export interface ProfileFieldType {
  label: string;
  value: React.ReactNode;
  editComponent?: React.ReactNode;
  colSpan?: 1 | 2;
  mono?: boolean;
}

interface ProfileFieldProps {
  field: ProfileFieldType;
  editing: boolean;
}

const ProfileField: React.FC<ProfileFieldProps> = ({ field, editing }) => {
  if (editing && field.editComponent) {
    return <>{field.editComponent}</>;
  }

  return (
    <Box>
      <Typography
        variant="caption"
        sx={{ color: 'grey.500', fontWeight: 500 }}
      >
        {field.label}
      </Typography>
      <Typography
        variant="body1"
        component="div"
        sx={{
          color: 'grey.900',
          fontWeight: 500,
          fontFamily: field.mono ? '"JetBrains Mono", monospace' : undefined,
        }}
      >
        {field.value ?? '-'}
      </Typography>
    </Box>
  );
};

export default ProfileField;
